import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import { administrationRequests } from "api/administrationApi";

const DeactivateDialog = ({ wardName, id }) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const handleSubmit = async () => {
    await dataProvider.customRequest(administrationRequests.deactivateWard(id), null, "PUT");
    refresh();
    notify("Успешно деактивиране на болнично отделение", { type: "success" });
  };

  return (
    <ConfirmModal
      onConfirm={handleSubmit}
      titleContent={"Деактивирай"}
      triggerButton={
        <Button
          label="Деактивирай"
          startIcon={<DoNotDisturbAltIcon />}
          color="error"
        />
      }
      message={`Сигурни ли сте, че искате да деактивирате болнично отделение - ${wardName}?`}
    />
  );
};

export default DeactivateDialog;
